import { useQuery } from '@tanstack/react-query'

import { listPublishersService } from '../services/advertiser-publisher'

export const usePublisherWalletConfig = (publisherId?: string) => {
  return useQuery({
    enabled: !!publisherId,
    queryKey: ['publisherConfig', publisherId],
    queryFn: async () => {
      if (!publisherId) throw new Error('Publisher ID is required')

      const response = await listPublishersService({
        publisher_id: publisherId,
        count: false
      })
      const publisher = response?.data?.publishers?.[0]

      return {
        auto_balance_transfer: publisher?.auto_balance_transfer,
        daily_transfer_limit: publisher?.daily_transfer_limit,
        monthly_transfer_limit: publisher?.monthly_transfer_limit
      }
    }
  })
}
